export const opcoesRenda = [
  { value: '1', label: 'Percentual Saldo' },
  { value: '2', label: 'Temporária' },
  { value: '3', label: 'Vitalícia' },
  { value: '4', label: 'Conjugada' },
];
